import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Instruction } from '../utilities/utility-components';
import { Appheader } from '../header/header-component';
import { DialogBox } from '../dialog/dialog-component';
import { AuthService } from '../services/auth-service';


function LoginPage() {
  const navigate = useNavigate();
  const [isShow, setShow] = useState(false);
  const [message, setMessage] = useState('');
  const [loginStatus, setLoginStatus] = useState(0)
  const [authObject, setAuthObject] = useState(null)

  useEffect(() => {
    if (loginStatus.status === 200 && authObject !== null) {
      // Clear any sessionStorage residue from a previous account on this tab
      // (recorder processing key, viewer token, pending cs330 join intents).
      // sessionStorage IS per-tab so this only matters if a user logs out and
      // logs in as a different account in the same tab — without this, the
      // new user could land in the previous user's group via stale state.
      try {
        const STALE_KEYS = [
          'byod_processing_key', 'byod_session_id', 'byod_device_id',
          'byod_name', 'byod_pcode', 'byod_closed_session',
          'byod_prev_sdid', 'byod_prev_sid',
          'byod_viewer_token', 'byod_viewer_session_device_id',
          'byod_viewer_session_id', 'byod_viewer_recorder_name',
          'cs330_pending_passcode', 'cs330_pending_name',
          'cs330_pending_viewer_code',
        ];
        STALE_KEYS.forEach(k => sessionStorage.removeItem(k));
      } catch (_) {}
      const dest = authObject.role === 'study' ? '/app'
                 : authObject.role === 'student' ? '/student-app'
                 : authObject.role === 'math' ? '/math'
                 : '/home';
      return navigate(dest) //,{state: authObject}
    } else if (loginStatus.status === 400) {
      setMessage(loginStatus.message);
      setShow(true);
    } else if (loginStatus.status === 401) {
      return navigate('/login')
    } else if (loginStatus.status === 600) {
      setMessage("Inavlid Username or Password");
      setShow(true);
    }
  }, [loginStatus,authObject])

  
  const dialogheader = 'Login Failed';

  const backClick = () => {
    return navigate('/')
  }

  const closeDialogBox = () => {
    setShow(false);
  }

  const checkLogin = () => {
    const username = document.getElementById("username").value.trim();
    const password = document.getElementById("password").value.trim();
    if (username === '') {
      setMessage("Please Enter Your Username");
      setShow(true);
      document.getElementById("username").focus();
    } else if (password === '') {
      setMessage("Please Enter Your Password");
      setShow(true);
      document.getElementById("password").focus();
    } else {
      new AuthService().login(username, password, setLoginStatus,setAuthObject);
    }

  }

  return (
    <div className="main-container items-center text-center">

      <Appheader
        title="Sign In"
        leftText={false}
        rightText={""}
        rightEnabled={false}
        nav={backClick} />
      <br></br>
      <Instruction instructions="Please enter your username and password." />

      <input className="text-box my-2 small-section" placeholder="username / email" name="username" id='username' />
      <input className="text-box small-section" placeholder="password" type="password" name="password" id='password' />

      <button className="wide-button"  onClick={checkLogin}>
        Sign In
      </button>

      <DialogBox
        itsclass={"add-dialog"}
        heading={dialogheader}
        message={message}
        show={isShow}
        closedialog={closeDialogBox} />
    </div >
  )
}

export { LoginPage }
